// LazyLoadWrapper.js
import React, { useRef, useState, useEffect, Suspense, Fragment } from "react";
import ShimmerLoader from "../ShimmerLoader";
import HospitalTestType from "./index";

// const HospitalTestType = React.lazy(() => import("./"));
// const HospitalTestType = React.lazy(() => import("./"));

function HospitalTestTypeLazyLoadWrapper(props) {
  const {Fullscreen,Highcharts,HospitalTestTypeLoader,hospitalCityData,hospitalCityTotal,hospitalNameData
    ,testTypeTotalCount,testTypeGraphLoader,testTypeGraphData,testTypePie
    
  } = props;
  
  const containerRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); 
        
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.3,
      }
    );
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => observer.disconnect();
 
  }, []);
  return (
    <Fragment>
      <div
       ref={containerRef} 
      //  style={{ minHeight: "500px" }}
      >
        {isVisible && (
          <Suspense fallback={<ShimmerLoader />}>
            <Fragment>
              {HospitalTestTypeLoader === true && <ShimmerLoader />}
              {HospitalTestTypeLoader === false  &&  <HospitalTestType
                hospitalCityData={hospitalCityData}
                hospitalCityTotal={hospitalCityTotal}
                hospitalNameData={hospitalNameData}
                Fullscreen={Fullscreen}
                Highcharts={Highcharts}
               testTypeTotalCount={testTypeTotalCount}
               testTypeGraphLoader={testTypeGraphLoader}
                testTypeGraphData={testTypeGraphData}
                testTypePie={testTypePie}
              />}
            </Fragment>
         </Suspense>
        )}
      </div>
    </Fragment>
  );
}

export default HospitalTestTypeLazyLoadWrapper;
